import { render, staticRenderFns } from "./VueNotificationBar.vue?vue&type=template&id=316972cb&"
import script from "./VueNotificationBar.vue?vue&type=script&lang=js&"
export * from "./VueNotificationBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VChip,VCol,VIcon,VList,VListItem,VListItemContent,VListItemGroup,VRow,VSpacer,VTab,VTabs,VToolbar,VTooltip})


/* vuetify-loader */
import installIcons from "!../../../../node_modules/vuetify-loader/lib/runtime/installIcons.js"
import { mdiArrowRight } from '@mdi/js';
import { mdiCheck } from '@mdi/js';
import { mdiEmailOpenOutline } from '@mdi/js';
import { mdiEmailOutline } from '@mdi/js';
import { mdiRefresh } from '@mdi/js';
installIcons(component, {mdiArrowRight,mdiCheck,mdiEmailOpenOutline,mdiEmailOutline,mdiRefresh})
